import React from "react"
import Skeleton from "react-loading-skeleton"
import DynamicSkeleton from "../../components/DynamicSkeleton"

const columnConfig = {
  Name: { content: <Skeleton width="210px" />, center: false },
  Email: { content: <Skeleton width="210px" />, center: false },
  "Phone No.": {
    content: <Skeleton height="20px" width="100px" />,
    center: true,
  },
  Role: { content: <Skeleton height="20px" width="100px" />, center: true },
  Action: {
    content: (
      <div className="d-flex justify-content-center gap-2">
        <Skeleton height="30px" width="30px" />
        <Skeleton height="30px" width="30px" />
      </div>
    ),
    center: true,
  },
}

const ManagePermissionsSkeleton = ({ infiniteScroll, rows = 6 }) => {
  return (
    <DynamicSkeleton
      rows={rows}
      columnConfig={columnConfig}
      infiniteScroll={infiniteScroll}
    />
  )
}

export default ManagePermissionsSkeleton
